/**
 * Created by danielr on 08-JUN-15.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var NameUtility = require("utils/NameUtility");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var AuthenticationServerView = require("manager-views/data-sources/integrations/authentication/AuthenticationServerView");
    var AuthenticationServerModel = require("manager-models/data-sources/integrations/authentication/AuthenticationServerModel");
    var AuthenticationServerController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AuthenticationServerController = Marionette.Controller.extend({
            initialize: function (options) {
                LEManager.logger.debug("bind to events","AuthenticationServerController:initialize");
                this.channel = LEManager.media.channel("dataSources");

                this.authTypeStates = [];

                this._initPageComponent();
                this._bindEvents();
            },

            show: function() {
                LEManager.logger.debug("call of show","AuthenticationServerController:show");
                this.pageView.showLoader();
                this.listenTo(Backbone.history, "route", this._closePage);

                this._fetchConnectorCollection();
            },
            getMainView:function () {
                return this.pageView;
            },

            _bindEvents: function(){
                LEManager.logger.debug("call of _bindEvents","AuthenticationServerController:_bindEvents");
                this.listenTo(this.channel, ManagerConfig.dataSources.mainConfig.authenticationServer.TRIGGERING.CLOSE, this._onCloseCancel);
                this.listenTo(this.channel, ManagerConfig.dataSources.mainConfig.authenticationServer.TRIGGERING.SAVE, this._saveAuthenticationServer);
                this.listenTo(this.channel, ManagerConfig.dataSources.mainConfig.authenticationServer.TRIGGERING.AUTH_TYPE_CHANGE, this._onAuthTypeChange);
            },

            _initPageComponent: function(){
                LEManager.logger.debug("call of _initPageComponent","AuthenticationServerController:_initPageComponent");
                this.pageView = new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    view:  null,
                    header: {
                        title: LE.translator.translate("LEManager.manager.AuthenticationServer.header.title"),
                        description: LE.translator.translate("LEManager.manager.AuthenticationServer.header.description")
                    }
                });
                this.listenTo(this.pageView, "close", this._onPageClose);
            },
            _onCloseCancel: function(){
               this._navigateOut();
            },
            _navigateOut: function() {
                LEManager.logger.debug("AuthenticationServerController:_navigateOut");

                var previousApplicationRoute = LE.context.get("previousApplicationRoute");
                if (_.isUndefined(previousApplicationRoute)){ //in case of this page is loaded directly (first navigation), if close is pressed then redirect to the data sources page
                    LEManager.router.navigateNonBackable(ManagerConfig.dataSources.mainConfig.general.dataSourcesListRoutePath);
                    return;
                }

                LEManager.router.navigateBack();

            },

            _fetchConnectorCollection: function(){
                LEManager.logger.debug("call of _fetchConnectorCollection","AuthenticationServerController:_fetchConnectorCollection");
                var that = this;
                this.authenticationServerCollection = LEManager.getModuleDataManager().getAuthenticationServerCollection();
                that._setConfiguration(this.authenticationServerCollection);
                that._onFetchConnectorCollectionSuccess();
            },

            _setConfiguration: function(authenticationServerCollection){
                LEManager.logger.debug("call of _setConfiguration","AuthenticationServerController:_setConfiguration");
                if (authenticationServerCollection.isAuthEmpty()){
                    //no auth defined yet
                    LEManager.logger.debug("connectorCollection is empty","AuthenticationServerController:_setConfiguration");
                    this.authenticationServerModel = new AuthenticationServerModel();
                    this.authenticationServerModel.setAuthName(NameUtility.getUniqueName(authenticationServerCollection, LE.translator.translate("LEManager.manager.AuthenticationServer.title")), {silent: true});
                }
                else {
                    var authenticationServerModel = authenticationServerCollection.getFirstAuthModel();
                    /*
                    we clone the model so that if a cancel/close is performed, the changes
                    won't be applied to the original model. example of change: change the
                    auth type
                     */
                    this.authenticationServerModel = authenticationServerModel.clone();
                    this.authenticationServerModel.setRevision(authenticationServerModel.getRevision(true));

                    //this.savedAuthTypeId is the id stored in the DB. we need to differenciate from auth saved in DB and new one
                    this.savedAuthTypeId = this.authenticationServerModel.getAuthType();
                    LEManager.logger.debug("this.savedAuthTypeId: " + this.savedAuthTypeId,"AuthenticationServerController:_setConfiguration");

                    this.authenticationServerModel.populateAuthTypeModel();
                    LEManager.logger.debug("setAuthTypeModel successfully called","AuthenticationServerController:_setConfiguration");
                }
            },

            _onFetchConnectorCollectionSuccess: function(){
                LEManager.logger.debug("call of _onFetchConnectorCollectionSuccess","AuthenticationServerController:_onFetchConnectorCollectionSuccess");
                this.authenticationView = new AuthenticationServerView({
                    model: this.authenticationServerModel
                });
                this.pageView.setInsideView(this.authenticationView);

                this._closeLoader();
            },

            _onAuthTypeChange: function(data){
                LEManager.logger.debug("call of _onAuthTypeChange","AuthenticationServerController:_onAuthTypeChange");
                /* data structure:
                 {
                    selectedAuthTypeId: value.selectedKey, //the new selected type id
                    previousState: {
                        authTypeId: this.currentAuthTypeId, //the current type id
                        authTypeModel: this.model.getAuthTypeModel() //the current data
                    }
                 }
                 */
                if (!_.isNull(data)){
                    LEManager.logger.debug("data: " + data,"AuthenticationServerController:_onAuthTypeChange");
                    this._saveAuthTypeState(data);

                    //we build the view and pass the corresponding authTypeModel according the data previousState
                    var authTypeData = this._getSavedAuthTypeState(data.selectedAuthTypeId);
                    var authDataConfig = _.isUndefined(authTypeData) ? {} : authTypeData.authTypeModel.toJSON();
                    //newAuth is used to differenciate between auth saved in DB and new auth
                    var newAuth = (this.savedAuthTypeId !== data.selectedAuthTypeId);

                    this.authenticationServerModel.populateAuthTypeModel(data.selectedAuthTypeId, authDataConfig, newAuth);
                }
            },

            _getSavedAuthTypeState: function(authTypeId){
                var state = _.find(this.authTypeStates, function(item){
                    return item.authTypeId === authTypeId;
                });
                return state;
            },

            _saveAuthTypeState: function(data){
                var state = this._getSavedAuthTypeState(data.previousState.authTypeId);
                if (!_.isUndefined(state)){
                    state.authTypeModel = data.previousState.authTypeModel;
                }
                else {
                    this.authTypeStates.push(data.previousState);
                }
            },

            _saveAuthenticationServer: function(){
                LEManager.logger.debug("call of _saveAuthenticationServer","AuthenticationServerController:_saveAuthenticationServer");
                this.pageView.showLoader();
                if (this.authenticationServerModel.isDeleteAction()) {
                    LEManager.logger.debug("this is a delete action","AuthenticationServerController:_saveAuthenticationServer");
                    this._applyDelete();
                }
                else {
                    LEManager.logger.debug("this is a save action","AuthenticationServerController:_saveAuthenticationServer");
                    this._applySave();
                }
            },

            _applySave: function(){
                LEManager.logger.debug("call of _applySave","AuthenticationServerController:_applySave");
                this.authenticationServerModel.save(null,{
                    success: _.bind(function (model, resp, options) {
                        LEManager.logger.debug("authenticationServerModel.save is successful","AuthenticationServerController:_applySave");
                        LEManager.notifier.showSuccess({
                            content: LE.translator.translate("LEManager.manager.dataSources.authentication.server.save.success")
                        });
                        this._closeLoader();
                        this._navigateOut();
                    },this),

                    error: _.bind(function (model, resp, options) {
                        LEManager.logger.debug("authenticationServerModel.save is NOT successful","AuthenticationServerController:_applySave");
                        this._closeLoader();
                        LEManager.logger.error("save authentication server model error. - AuthenticationServerController:_applySave", model);
                        LEManager.notifier.showError(LE.translator.translate('LEManager.manager.dataSources.authentication.server.save.error'));
                    },this)
                });
            },

            _applyDelete: function(){
                LEManager.logger.debug("call of _applyDelete","AuthenticationServerController:_applyDelete");
                this.authenticationServerModel.destroy({
                    wait:true,
                    success: _.bind(function () {
                        LEManager.logger.debug("delete is successfull","AuthenticationServerController:_applyDelete");
                        ///TODO: notifier showsuccess
                        this._closeLoader();
                        this._navigateOut();
                    },this),

                    error: _.bind(function (model, resp, options) {
                        LEManager.logger.debug("delete is NOT successfull","AuthenticationServerController:_applyDelete");
                        this._closeLoader();
                        var errorMsg = LE.translator.translate('LEManager.manager.dataSources.authentication.server.delete.error');
                        if (resp && _.has(resp,"responseError") && _.has(resp.responseError,"internalCode")){
                            if (resp.responseError.internalCode === ErrorCodes.dependencyConflict) {
                                LEManager.logger.debug("delete authentication server model conflict error.", "AuthenticationServerController:_applyDelete", resp.responseError);
                                errorMsg = LE.translator.translate("LEManager.manager.dataSources.authentication.server.delete.conflict.error");
                            }
                        }
                        LEManager.logger.error("delete authentication server model error.", "AuthenticationServerController:_applyDelete", model);
                        LEManager.notifier.showError(errorMsg);
                    },this)
                });
            },

            _closeLoader: function(){
                this.pageView.closeLoader();
            },

            /**
             *                                  ############# _onPageClose #############
             *
             * is called everytime the PageView is being closed
             */
            _onPageClose: function() {
                this.authTypeStates = [];

                this.stopListening(this.pageView);
                this.stopListening(Backbone.history);
                this._initPageComponent();
            },

            /**
             *                                  ############# _closePage #############
             *
             * is called everytime history back is triggered
             *
             * @param options
             * @param handler
             * @private
             */
            _closePage: function(options, handler) {
                LEManager.logger.debug("AuthenticationServerController:_closePage");

                if (handler.indexOf("LEManager") !== 0) { // if the route is not to LEManager we need to close the pageView
                    LEManager.logger.info ("close the page component","AuthenticationServerController:_closePage", handler);

                    this.pageView.close();


                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return  AuthenticationServerController;
});

